const HTML_CHAR_BULLET: string = '•';

export default HTML_CHAR_BULLET;
